import { Dropdown, useTranslator, getLocale } from "@sia/style-guide";
import { useCallback, useContext, useEffect, useState } from "react";
import { WizarContext } from "contexts/WizardContext";
import { juniorOtherAddressesInfoActionCreator } from "contexts/WizardContext";
import GlobalContext from "contexts/GlobalContext";
import webPlatformAdapter from "common/Adapters/WebPlatformAdapter/WebPlatformAdapter";
import pgAdapter from "common/Adapters/PGAdapter/PGAdapter";
import { initialWizardFormState } from "contexts/WizardContext";
import { composeAddressLabel } from "pages/Wizard/utils";

const OtherAddressesInfo = ({ errors, setErrors }) => {
  const translate = useTranslator();
  const { language } = useContext(GlobalContext);
  const { state, dispatch } = useContext(WizarContext);
  let otherAddresses = state.junior.otherAddressesInfo;
  let otherAddressInfoErrors = errors.junior.otherAddressesInfo;

  let changState = useCallback((payload) => dispatch(juniorOtherAddressesInfoActionCreator(payload)), [dispatch]);
  const resetInputFieldError = (property) => {
    if (errors.junior.otherAddressesInfo[property]) {
      setErrors((errorsState) => ({
        ...errorsState,
        junior: {
          ...errorsState.junior,
          otherAddressesInfo: { ...errorsState.junior.otherAddressesInfo, [property]: "" },
        },
      }));
    }
  };

  const { user } = useContext(GlobalContext);
  const [addresses, setAddresses] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      let lang = getLocale(language);
      const data = await webPlatformAdapter.request("GET", "rpc/get_addresses_single", { lang });
      let addresses = data.filter((e) => e.label !== null);
      addresses = addresses.map((e) => ({ id: e.id, label: composeAddressLabel(e) }));
      setAddresses(addresses);
    }
    if (user) {
      fetchData();
    }
  }, [user, language]);

  useEffect(() => {
    if (user) {
      pgAdapter.getWizardSession(({ data }) => {
        const defaultOtherAddressInfo = { ...initialWizardFormState.junior.otherAddressesInfo };
        const { otherAddressesInfo } = data?.junior || {};
        const { contact, delivery, invoice } = otherAddressesInfo || defaultOtherAddressInfo;
        changState({
          contact,
          delivery,
          invoice,
        });
      });
    }
  }, [user, changState]);

  const setUserSession = (obj) => {
    pgAdapter.getWizardSession(({ data }) => {
      const updatedSession = {
        ...data,
        junior: { ...(data.junior || {}), otherAddressesInfo: { ...(data?.junior?.otherAddressesInfo || {}), ...obj } },
      };
      pgAdapter.setWizardSession({ ...updatedSession });
    });
  };
  return (
    <div className="otherAddresses-info-page">
      <p className="sia-text-11 sia-margin-03-bottom">{translate("wizard.form.single.delivery-address.info")}</p>
      <Dropdown
        id={"junior-otherAddresses-page-contact"}
        label={translate("wizard.form.single.delivery-address.contact.label")}
        items={addresses}
        value={otherAddresses.contact}
        required={true}
        onChange={(event, value) => {
          resetInputFieldError("contact");
          changState({ contact: value });
          setUserSession({ contact: value });
        }}
        placeholder={translate("wizard.form.single.placeholder")}
        invalid={otherAddressInfoErrors.contact}
        invalidText={otherAddressInfoErrors.contact}
      />
      <Dropdown
        id={"junior-otherAddresses-page-delivery"}
        label={translate("wizard.form.single.delivery-address.deleviry.label")}
        items={addresses}
        value={otherAddresses.delivery}
        required={true}
        onChange={(event, value) => {
          resetInputFieldError("delivery");
          changState({ delivery: value });
          setUserSession({ delivery: value });
        }}
        placeholder={translate("wizard.form.single.placeholder")}
        invalid={otherAddressInfoErrors.delivery}
        invalidText={otherAddressInfoErrors.delivery}
      />
      <Dropdown
        id={"junior-otherAddresses-page-invoice"}
        label={translate("wizard.form.single.delivery-address.invoice.label")}
        items={addresses}
        value={otherAddresses.invoice}
        required={true}
        onChange={(event, value) => {
          resetInputFieldError("invoice");
          changState({ invoice: value });
          setUserSession({ invoice: value });
        }}
        placeholder={translate("wizard.form.single.placeholder")}
        invalid={otherAddressInfoErrors.invoice}
        invalidText={otherAddressInfoErrors.invoice}
      />
    </div>
  );
};

export default OtherAddressesInfo;
